import React from 'react';
import { connect } from 'react-redux';
import { AspectRatio } from '@ff-os/shared-react/components/aspect-ratio/AspectRatio';
import { PhotoEditModal } from '@ff-os/shared-react/components/photo-edit/photo-edit-modal/PhotoEditModal';
import { Area } from '@ff-os/shared-utils/types/Area';
import { selectVariantById } from '@ff-scene-plugins/photo-prints-redux/selectors/variantSelectors';
import { selectGroupById } from '@ff-scene-plugins/photo-prints-redux/slices/groupsSlice';
import { actions as photoActions } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpDispatch, PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { getCropAspectRatio } from '@ff-scene-plugins/photo-prints-shared/getCropAspectRatio';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { selectFilledPhotoById, selectFilterByPhotoId, selectOriginalUrlForPhotoById } from '../../../_redux-photos';
import { selectSizeByPhotoId } from '../../../_redux-sizes';
import { PhotoPrintCropPreview } from './PhotoPrintCropPreview';

const _PhotoPrintCropModal = ({
    apply, isOpen, close,
    photo, size,
    filter, updateFilter,
    photoId, url, hasBorder
}: Props) => {

    const hasPhotoFunBorder = !!photo.reproString;
    const aspectRatio = getCropAspectRatio(size, photo, hasBorder);

    return (
        <PhotoEditModal
            imageSize={{ width: photo.width, height: photo.height }}
            activeCropBox={photo.crop}
            applyCropBox={apply}
            aspectRatio={aspectRatio}
            autoFaceCenter={photo.autoFaceCenter}
            detections={photo.detections}
            close={close}
            isOpen={isOpen}
            filter={filter}
            updateFilter={updateFilter}
            overlayUrl={url}
            hasPhotoFunBorder={hasPhotoFunBorder}
        >
            <AspectRatio width={photo.width} height={photo.height}>
                <PhotoPrintCropPreview photoId={photoId} />
            </AspectRatio>
        </PhotoEditModal>
    );
};

type OwnProps = {
    photoId: string;
};

type Props = OwnProps & {
    url: string;
    close: () => void;
    isOpen: boolean;
    apply: (cropBox: Area) => void;
    photo: PhotoPrintsJson.ProcessedPhoto;
    size: PhotoPrintsJson.Size;
    filter: string | null;
    updateFilter: (filter: string | null) => void;
    hasBorder: boolean;
};

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => {
    const photo = selectFilledPhotoById(state, ownProps.photoId)!;
    const group = selectGroupById(state, photo.groupId);
    const variant = group ? selectVariantById(state, group.variantId) : null;
    const hasPhotoFunBorder = group && typeof group.magicBorderId === 'string' && group.magicBorderId.trim() !== '';
    const hasBorder = Boolean(variant?.borderId !== "without-border" || hasPhotoFunBorder);

    return {
        url: selectOriginalUrlForPhotoById(state, ownProps.photoId)!,
        photo,
        size: selectSizeByPhotoId(state, ownProps.photoId)!,
        filter: selectFilterByPhotoId(state, ownProps.photoId)!,
        hasBorder
    };
};

const mapDispatchToProps = (dispatch: PhotoPrintsPdpDispatch, ownProps: OwnProps) => ({

    apply: (crop: Area) => dispatch(photoActions.updateCrop({ photoId: ownProps.photoId, crop: crop })),

    updateFilter: (filter: string | null) =>
        dispatch(photoActions.updateFilter({ photoId: ownProps.photoId, filter: filter }))
});

export const PhotoPrintCropModal = connect(
    mapStateToProps,
    mapDispatchToProps
)(_PhotoPrintCropModal);